

















import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class ConfirmationModal extends Vue {
  private confirm() {
    this.$emit('confirmed');
    (this.$parent as any).close();
  }
}
